<template>
  <span
    class="chat-mention rounded-sm"
    :class="{ highlighted }"
  >@{{ data }}</span>
</template>

<script>
import { PING_EVERYONE, PING_MODS } from '@/utils/constants/chat'
import { ROLE_MODERATOR } from '@/utils/constants/permissions'
import User from '@/store/models/user/User'

export default {
  props: {
    data: {
      type: String,
      required: true,
    },
    user: {
      type: [User, Object],
      default: null,
    },
  },
  computed: {
    highlighted() {
      const { user, data: mention } = this

      if (mention === PING_EVERYONE) return true

      if (!user) return false

      if (mention === PING_MODS && user.role === ROLE_MODERATOR) {
        return true
      }

      return mention === user.friendId
    },
  },
}
</script>

<style lang="scss" scoped>
.chat-mention {
  padding: 0 2px;
  color: primary();
  background-color: grey(600);

  &.highlighted {
    color: grey(100);
    background-color: primary(700);
  }
}
</style>
